const EVENT_JOB_VIEW_LINK_CLICK      = 'job_view_link_click';
const EVENT_JOB_VIEW                 = 'job_view';
const EVENT_JOB_APPLY_CLICK          = 'job_apply_click';
const EVENT_SUBSCRIBED_TO_JOB_ALERTS = 'job_alerts_subscribed';
const EVENT_PROFESSIONAL_PROFILE_REGISTERED = 'professional_profile_registered';
const EVENT_EMPLOYER_REGISTERED      = 'employer_registered';
const EVENT_EMPLOYER_POSTED_JOB      = 'employer_posted_job';
const EVENT_EMPLOYER_PURCHASED_PRODUCT    = 'employer_purchased_product';

const DEBUG_ANALYTICS = true;

// Resolved at call time: the gtag.js/GTM snippet lives in tenant-pasted custom
// code and may run after this module is evaluated.
function getGTag(){
  return typeof window.gtag === 'function' ? window.gtag : null;
}

function getUtmParamsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return {
    'utm_source'   : params.get('utm_source') || '',
    'utm_medium'   : params.get('utm_medium') || '',
    'utm_campaign' : params.get('utm_campaign') || '',
    'utm_content'  : params.get('utm_content') || '',
    'utm_term'     : params.get('utm_term') || '',
  };
}

function getCommonDataForEvents() {
  return {
    'page_url' : window.location.href,
    'referral' : document.referrer,
    ...getUtmParamsFromUrl(),
  };
}

function getEvenDataFromJob(job){
  return {
    job_id: job.id,
    job_title: job.title,
    job_apply_by: job.apply_by,
    job_apply_to: job.apply_to,
    job_location: job.location,
    job_employer: job.employer ? job.employer.name : null,
    job_details_path: job.job_details_path ? job.job_details_path : '',
  };
}

function getEvenDataFromEmployerProduct(employerProduct){
  try{
    return {
      product_id: employerProduct.product.id,
      product_name: employerProduct.product.name,
      product_type: employerProduct.product.type,
      final_price:employerProduct.final_price
    };
  } catch (e) {
    return null;
  }
}

function reportEventToGoogle(eventName, eventData){
  if (window.$inBuilderMode || window.$actingVisitorIsBot) {
    return;
  }

  try {
    const gtag = getGTag();

    if (gtag) {
      if (eventData) {
        gtag('event', eventName, eventData);
      } else {
        gtag('event', eventName);
      }
    } else {
      // GTM installs don't define window.gtag; they consume dataLayer pushes.
      // GTM replays pushes made before its snippet loads, so this also covers
      // snippets pasted into the body-end custom code block.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: eventName, ...(eventData || {})});
    }

    if (DEBUG_ANALYTICS) {
      console.log(eventName, eventData);
    }
  } catch (e) {
    console.error(e);
  }
}

function supportsKeepalive() {
  try {
    return typeof window.fetch === 'function' && 'keepalive' in new Request('/');
  } catch (e) {
    return false;
  }
}

function withApiBaseUrl(path) {
  return (axios.defaults.baseURL || '').replace(/\/$/, '') + path;
}

function getKeepaliveHeaders() {
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': window.$jBoard.csrf_token,
  };

  const common = axios.defaults.headers.common || {};

  Object.keys(common).forEach(name => {
    if (common[name]) {
      headers[name] = common[name];
    }
  });

  return headers;
}

function reportEventToJBoard(eventName, eventData) {

  if (window.$inBuilderMode || window.$actingVisitorIsBot) {
    return;
  }

  const path = '/api/analytics/events/' + eventName;
  const payload = {...eventData, ...getCommonDataForEvents()};

  if (!supportsKeepalive()) {
    axios.post(path, payload);
    return;
  }

  fetch(withApiBaseUrl(path), {
    method: 'POST',
    keepalive: true,
    credentials: 'same-origin',
    headers: getKeepaliveHeaders(),
    body: JSON.stringify(payload),
  }).catch(() => {
    axios.post(path, payload);
  });
}

export function reportJobViewEvent(job) {
  reportEventToGoogle(EVENT_JOB_VIEW, getEvenDataFromJob(job));
  reportEventToJBoard(EVENT_JOB_VIEW, {'job_id': job.id})
}

export function reportJobViewLinkClickEvent(job) {
  reportEventToGoogle(EVENT_JOB_VIEW_LINK_CLICK, getEvenDataFromJob(job));
}

export function reportJobApplyEvent(job) {
  reportEventToGoogle(EVENT_JOB_APPLY_CLICK, getEvenDataFromJob(job));
  reportEventToJBoard(EVENT_JOB_APPLY_CLICK, {'job_id': job.id});
}

export function reportJobAlertSubscriptionEvent() {
  reportEventToGoogle(EVENT_SUBSCRIBED_TO_JOB_ALERTS, null);
}

export function reportProfessionalProfileRegisteredEvent() {
  reportEventToGoogle(EVENT_PROFESSIONAL_PROFILE_REGISTERED, null);
}

export function reportEmployerRegisteredEvent() {
  reportEventToGoogle(EVENT_EMPLOYER_REGISTERED, null);
}

export function reportEmployerPostedJobEvent() {
  reportEventToGoogle(EVENT_EMPLOYER_POSTED_JOB, null);
}

export function reportEmployerPurchasedProductEvent(employerProduct) {
  reportEventToGoogle(EVENT_EMPLOYER_PURCHASED_PRODUCT, getEvenDataFromEmployerProduct(employerProduct));
}
